module.exports = __webpack_public_path__ + "static/media/capa-home-mobile.0970d6f3.jpg";